import React from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingSection from "@/features/pathpick/features/landing/components/PathPickLandingSection";
import PathPickLandingProductImage from "@/features/pathpick/features/landing/components/PathPickLandingProductImage";
import {
  PATHPICK_LANDING_COLORS,
  PATHPICK_LANDING_IMAGES,
} from "@/features/pathpick/features/landing/constants";

// 실제 상품 카드로 수익성을 비교하는 섹션 — 핫딜 상품과 일반 상품 두 묶음.
function PathPickLandingProductShowcaseSection() {
  const { t } = useI18nHelper();

  return (
    <PathPickLandingSection
      title={t("path_pick_landing:showcase.title")}
      description={t("path_pick_landing:showcase.description")}
    >
      <Flex flexDirection={"column"} gap={"16px"}>
        <Flex gap={"8px"} alignItems={"center"}>
          <Text
            textStyle={"body-md-bold"}
            fontSize={"16px"}
            color={PATHPICK_LANDING_COLORS.textStrong}
          >
            {t("path_pick_landing:showcase.hot_deal.title")}
          </Text>
          <Flex
            padding={"2px 8px"}
            borderRadius={"full"}
            border={`1px solid ${PATHPICK_LANDING_COLORS.amber}`}
          >
            <Text
              textStyle={"caption-medium"}
              color={PATHPICK_LANDING_COLORS.amber}
            >
              {t("path_pick_landing:showcase.example_badge")}
            </Text>
          </Flex>
        </Flex>
        <Text textStyle={"body-sm-regular"} color={PATHPICK_LANDING_COLORS.textMuted}>
          {t("path_pick_landing:showcase.hot_deal.description")}
        </Text>
        {/* 카드 3장이 한 이미지로 묶여 있다. */}
        <Flex justifyContent={"center"}>
          <PathPickLandingProductImage
            src={PATHPICK_LANDING_IMAGES.hotDeal.src}
            alt={t("path_pick_landing:showcase.hot_deal.image_alt")}
            naturalWidth={PATHPICK_LANDING_IMAGES.hotDeal.width}
            naturalHeight={PATHPICK_LANDING_IMAGES.hotDeal.height}
          />
        </Flex>
        <Text textStyle={"caption-medium"} color={PATHPICK_LANDING_COLORS.textFaint}>
          {t("path_pick_landing:showcase.hot_deal.caption")}
        </Text>
      </Flex>

      <Divider borderColor={PATHPICK_LANDING_COLORS.divider} />

      <Flex flexDirection={"column"} gap={"16px"}>
        <Text
          textStyle={"body-md-bold"}
          fontSize={"16px"}
          color={PATHPICK_LANDING_COLORS.textStrong}
        >
          {t("path_pick_landing:showcase.normal.title")}
        </Text>
        <Text textStyle={"body-sm-regular"} color={PATHPICK_LANDING_COLORS.textMuted}>
          {t("path_pick_landing:showcase.normal.description")}
        </Text>
        <Flex justifyContent={"center"}>
          <PathPickLandingProductImage
            src={PATHPICK_LANDING_IMAGES.normal.src}
            alt={t("path_pick_landing:showcase.normal.image_alt")}
            naturalWidth={PATHPICK_LANDING_IMAGES.normal.width}
            naturalHeight={PATHPICK_LANDING_IMAGES.normal.height}
          />
        </Flex>
      </Flex>
    </PathPickLandingSection>
  );
}

export default PathPickLandingProductShowcaseSection;
